import React, { useState, useEffect } from "react";
import { InfoCircleFilled } from "@ant-design/icons";
import { Row, Col, Typography, Button } from "antd";
import { useBreakpoints } from "./ResponsiveBreakPoints";

const { Text } = Typography;

const DisclaimerBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { isMobile } = useBreakpoints();
  useEffect(() => {
    const isDismissed = localStorage.getItem("disclaimer_dismissed");
    if (!isDismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem("disclaimer_dismissed", "true");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "#f0f0f0",
        borderTop: "1px solid #d9d9d9",
        padding: isMobile ? "12px" : "16px 24px",
        zIndex: 10001,
        boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
      }}
    >
      <Row
        align={isMobile ? "top" : "middle"}
        gutter={[12, 8]}
        style={{
          marginRight: isMobile ? 0 : "80px", 
        }}
      >
        {/* ICON */}
        <Col xs={3} sm={1} style={{ textAlign: "center" }}>
          <InfoCircleFilled
            style={{
              fontSize: isMobile ? "16px" : "24px",
              color: "#8c8c8c",
              marginTop: isMobile ? "4px" : 0,
            }}
          />
        </Col>

        {/* TEXT */}
        <Col xs={21} sm={21}>
          <Text
            style={{
              fontSize: isMobile ? "10px" : "12px",
              color: "#595959",
              lineHeight: isMobile ? "1.5" : "1.4",
              display: "block",
              fontFamily: "Roboto-400"
            }}
          >
            Neither{" "}
            <strong>
              shreevastuproperties.com (Shree Vastu Management and Developers)
            </strong>{" "}
            nor third parties provide any warranty or guarantee as to the
            accuracy, timeliness, performance, completeness or suitability of
            the information and materials found or offered on this website for
            any particular purpose. You acknowledge that such information and
            materials may contain inaccuracies or errors and we expressly
            exclude liability for any such inaccuracies or errors to the fullest
            extent permitted by law. Users are strongly advised to exercise
            independent due diligence from other sources before relying upon any
            information or material published on website before taking any kind
            of decisions with respect to the listings of properties/projects and
            including but not limited to any other services provided on the
            website.
          </Text>
        </Col>

        <Col
          xs={24} 
          sm={2}
          style={{
            textAlign: isMobile ? "center" : "right",
            marginTop: isMobile ? "8px" : 0,
          }}
        >
          <Button
            type="primary"
            shape="circle"
            size={isMobile ?"middle" : "large"}
            onClick={handleDismiss}
            style={{
              backgroundColor: "#000",
              borderColor: "#000",
              fontWeight: "bold",
              fontSize: isMobile ? "10px" : "14px",
            }}
          >
            OK
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default DisclaimerBanner;
